module.exports = __webpack_public_path__ + "assets/img/openAI.ec8f5f8f.jpg";